/**
 * FTW — handover mobile.
 * - "Você viu N de T produtos" + barra acima do botão Carregar mais (snippets/load-more.liquid).
 * - Nota do produto (snippets/ftw-avaliacao.liquid) rola até as avaliações do Judge.me.
 *
 * Cuidado: o contador fica DENTRO de [data-products-grid]. O observador vigia só a lista de
 * produtos (filhos diretos da grade) e só escreve quando o número muda; senão a própria escrita
 * dispara o observador de novo e a página trava em laço infinito.
 */
(function () {
  var ultimo = '';

  function atualizaProgresso() {
    var grid = document.querySelector('[data-products-grid] [data-total-products]');
    var box = document.querySelector('[data-ftw-progresso]');
    if (!grid || !box) return;

    var total = parseInt(grid.dataset.totalProducts, 10) || 0;
    if (!total) return;
    var vistos = Math.min(grid.querySelectorAll('[data-product-index]').length, total);

    var chave = vistos + '/' + total;
    if (chave === ultimo) return;
    ultimo = chave;

    box.querySelector('[data-ftw-vistos]').textContent = vistos;
    box.querySelector('[data-ftw-total]').textContent = total;
    box.querySelector('[data-ftw-barra]').style.transform = 'scaleX(' + (vistos / total).toFixed(3) + ')';
    box.hidden = false;
  }

  var observada = null;
  var observador = new MutationObserver(function () {
    // A grade pode ser trocada inteira (filtros/ordenação): reaponta o observador.
    var grid = document.querySelector('[data-products-grid] [data-total-products]');
    if (grid !== observada) vigia(grid);
    atualizaProgresso();
  });

  function vigia(grid) {
    observador.disconnect();
    observada = grid;
    if (grid) observador.observe(grid, { childList: true });
    var container = document.querySelector('[data-products-grid]');
    if (container) observador.observe(container, { childList: true });
  }

  function inicia() {
    if (!document.querySelector('[data-products-grid]')) return;
    vigia(document.querySelector('[data-products-grid] [data-total-products]'));
    atualizaProgresso();
  }

  document.addEventListener('click', function (event) {
    var botao = event.target.closest('[data-ftw-scroll-reviews]');
    if (!botao) return;
    var alvo =
      document.getElementById('avaliacoes') ||
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-widget, .jdgm-review-widget, [id*="judge_me_reviews"]');
    if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Galeria do produto no celular (slider do tema, sem indicador): bolinhas embaixo da foto.
  function bolinhasGaleria() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('.product__slides').forEach(function (trilho) {
      var fotos = trilho.querySelectorAll('.product__slide');
      if (fotos.length < 2 || trilho.parentElement.querySelector('.ftw-dots')) return;

      var dots = document.createElement('div');
      dots.className = 'ftw-dots';
      dots.setAttribute('aria-hidden', 'true');
      fotos.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dots.appendChild(d);
      });
      trilho.insertAdjacentElement('afterend', dots);

      // A foto ocupa menos que a tela (a próxima aparece no canto): o passo é a foto + o espaço.
      var passo = function () {
        return fotos.length > 1 ? fotos[1].offsetLeft - fotos[0].offsetLeft : trilho.clientWidth;
      };
      var atual = 0;
      trilho.addEventListener('scroll', function () {
        var i = Math.round(trilho.scrollLeft / passo());
        if (trilho.scrollLeft >= trilho.scrollWidth - trilho.clientWidth - 2) i = fotos.length - 1;
        if (i === atual || !dots.children[i]) return;
        dots.children[atual].classList.remove('is-active');
        dots.children[i].classList.add('is-active');
        atual = i;
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { inicia(); bolinhasGaleria(); });
  } else {
    inicia();
    bolinhasGaleria();
  }
})();
